import { atom } from 'recoil';

export const prefixesManagement = atom({
  key: 'prefixes_list',
  default: {
    results: [],
    desc: true,
    order_by: 'id',
    total: null,
    size: 20,
    page: 1,
    screen: null,
    search_text: '',
    appeal_status: '',
  },
});

export const detailPrefix = atom({
  key: 'prefix_detail',
  default: {},
});
